export default __webpack_public_path__ + "static/media/news.1e3edb47.png";